import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  Button,
  Input,
  Tooltip,
  Form,
  Card,
  Select,
  message,
  Spin,
  DatePicker,
  Modal,
  Row,
  Col,
  Space,
  Badge,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import TripDetails from "./tripDetails";
import { CSVLink } from "react-csv";
import { ReactComponent as Track } from "../../assets/images/fluent_location-16-filled.svg";
import { ReactComponent as Lock } from "../../assets/images/locked.svg";
import { ReactComponent as UnLock } from "../../assets/images/unlocked.svg";
import { ReactComponent as File } from "../../assets/images/mingcute_document-2-line.svg";
import { ReactComponent as Battery } from "../../assets/images/Vector (2).svg";
import { ReactComponent as Completed } from "../../assets/images/Completed.svg";
import { ReactComponent as InProgress } from "../../assets/images/Frame 18.svg";
import UIModal from "../../Reusablecomponents/UIModal";
import { ReactComponent as Filter } from "../../../src/assets/images/filter-svgrepo-com (1).svg";
import styled from "styled-components";
import {
  ShipmentType,
  DispatchType,
  CargoFinishType as FinishType,
  TripTypeEnum,
  priorityType,
  LockStatus,
  TripStatus,
} from "../../Common/constant";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import { useNavigate } from "react-router-dom";
import { Placeholder } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const Customstyle = styled.div`
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .container_for_header_subtwo {
      display: flex;
      flex-wrap: wrap;
    }
    .container_for_headersub_three {
      display: flex;
      flex-wrap: wrap;
      justify-content: end;
    }
  }
  .container_for_header_subtwo {
    display: flex;
    align-items: center; /* Ensures all items align properly */
    gap: 10px; /* Adds spacing between elements */
  }

  .container_for_headersub_three {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
  }

  .container_for_header_subtwo > div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .container_Green {
    color: #2c963d;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Orange {
    color: #e4a400;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Red {
    color: #f20000;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  padding: 07px;
  .searchbar-style {
    width: 200px;
    border-radius: 12px;
  }
  .container_green {
    background-color: #2c963d;
    padding: 1px 20px 1px 20px;
    margin: 0px;
    border-radius: 14px;
    color: white;
  }
  .container_red {
    background-color: #ff8800;
    padding: 1px 20px 1px 20px;
    margin: 0px;
    border-radius: 14px;
    color: white;
  }
  .category-count-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 600;
    min-width: 110px;
    height: 19px;
    margin-left: 5px;
  }
  .recipients {
    max-width: 380px;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    display: flex;
    align-items: center;
  }
  .badge .ant-scroll-number {
    background-color: #ebf7ed !important;
    color: #5f6d8c !important;
    border-radius: 19px !important;
    min-width: 28px;
    height: 27px;
    line-height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    padding: 5px;
  }
  .Iconbg {
    width: 38px;
    height: 38px;
    border-radius: 60%;
    background-color: #ebf7ed;
  }
  .assignment-title-mobile {
    margin-bottom: 4px; /* or any value you prefer */
    display: block;
  }
`;
function TripMonitoring() {
  const navigate = useNavigate();
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [newLoading, setNewLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tripData, setTripData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [drawyeropen, setDrawyeropen] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [tripMonitorData, setTripMonitorData] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef(null);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const location = useLocation();
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [selectedCustomColumns, setSelectedCustomColumns] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [assignedCount, setAssignedCount] = useState([]);
  const [completedCount, setCompletedCount] = useState([]);
  const [inProgressCount, setInProgreeCount] = useState([]);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );

  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );

  const [newtimeandvalue, setnewtimeandvalue] = useState(null);
  const [formData, setFormData] = useState({
    company: userInfo?.MCID === 59 ? "" : userInfo.COMPNAME,
    consignor: "",
    transporter: "",
    priority: 1,
    dispatchtype: "",
    shipmenttype: "",
    pickup: "",
    dropoff: "",
    vehicle: "",
    triptype: "",
    finishtype: "",
    consignee: "",
    device: "",
    container: "",
    delivery: "",
    route: "",
    freedays: "",
    driver: "",
    phone: "",
  });
  const reftab = formData ? "Tripmonitoringcreate" : null;
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const [filterValues, setFilterValues] = useState({
    container: "",
    consignee: "",
    lockstatus: "",
    status: "",
    fromdate: "",
    todate: "",
    transporter: "",
    consignor: "",
    shipment: "",
    vehicle: "",
    device: "",
  });
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("TRPMONITOR", "CT"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("TRPMONITOR", "EX"),
    [reduxPermissions],
  );
  function generateKenyaTime(date = new Date()) {
    const options = {
      timeZone: "Africa/Nairobi",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour12: false,
    };
    const formatter = new Intl.DateTimeFormat("en-GB", options);
    const parts = formatter.formatToParts(date);

    const y = parts.find((p) => p.type === "year").value;
    const m = parts.find((p) => p.type === "month").value;
    const d = parts.find((p) => p.type === "day").value;
    const h = parts.find((p) => p.type === "hour").value;
    const min = parts.find((p) => p.type === "minute").value;
    const s = parts.find((p) => p.type === "second").value;

    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }

  let timeNow = generateKenyaTime();
  let afterOneHour = generateKenyaTime(new Date(Date.now() + 60 * 60 * 1000));

  useEffect(() => {
    setFormData((prev) => {
      return {
        ...prev,
        pickup: isEdit ? prev?.pickup : dayjs(timeNow) || "",
        dropoff: isEdit ? prev?.dropoff : dayjs(afterOneHour) || "",
      };
    });
  }, []);

  useEffect(() => {
    setnewtimeandvalue(timeNow);

    generateKenyaTime();
  }, []);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchTrips = async () => {
    try {
      setLoading(true);
      // Format dates if they exist
      const fromDateFormatted = filterValues?.fromdate
        ? dayjs(filterValues.fromdate).format("YYYY-MM-DD")
        : "";
      const toDateFormatted = filterValues?.todate
        ? dayjs(filterValues.todate).format("YYYY-MM-DD")
        : "";

      const { data } = await CALL_API(
        "GET",
        `container/pagination?page=${currentPage}&limit=${pageSize}&ContainerNo=${
          filterValues?.container
        }&Consignee=${filterValues?.consignee || ""}&Tripstatus=${
          filterValues?.status
        }&FromDate=${fromDateFormatted}&ToDate=${toDateFormatted}&Transporter=${
          filterValues?.transporter || ""
        }&Consignor=${filterValues?.consignor || ""}&ShipmentTypeId=${
          filterValues?.shipment
        }&ContainerVehId=${""}&DeviceID=${filterValues?.device}`,
      );

      let trips = data?.data || [];

      if (
        filterValues?.lockstatus !== "" &&
        filterValues?.lockstatus !== null
      ) {
        const lockStatus = Number(filterValues.lockstatus);
        trips = trips.filter((trip) => trip.LastStatus === lockStatus);
      }
      setAssignedCount(data?.assignedCount || 0);
      setInProgreeCount(data?.inProgressCount || 0);
      setCompletedCount(data?.completedCount || 0);
      setTotal(data?.totalRecords || 0);
      setTripData(trips);
    } catch (error) {
      console.error("fetchTrips error:", error);
      message.error("Failed to load trip data.");
    } finally {
      setLoading(false);
      setInitialized(true);
    }
  };

  //navigate function on home page
  useEffect(() => {
    if (location.state?.action === "openConsignmentDrawer") {
      setDrawyeropen(true); // open the consignment drawer
    }
  }, [location.state]);
  useEffect(() => {
    fetchTrips();
  }, [currentPage, pageSize, filterValues]);

  useEffect(() => {
    fetchAllCompany();
    fetchAllVehicle();
    fetchAllRoute();
    fetchAllDevice();
  }, []);

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      setVehicleList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllRoute = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllRoute");
      setRouteList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      const devices = data?.companies || [];
      setDeviceList(devices);

      // Extract FGUIDs from devices
      const fguids = devices.map((d) => d.FGUID).filter(Boolean);
      // If we have FGUIDs, call trip monitor
      if (fguids.length > 0) {
        fetchTripMonitor(fguids);
      }
    } catch (error) {
      console.error("[fetchAllDevice] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTripMonitor = useCallback(async (aDevices) => {
    try {
      const { data } = await CALL_API("POST", "container/tripMonitorList", {
        aDevices,
      });
      setTripMonitorData(data?.Result || []);
    } catch (error) {
      console.error("[fetchTripMonitor] error:", error);
    }
  }, []);

  //fectch  vehicle,device,route per company
  const [filteredVehicleList, setFilteredVehicleList] = useState([]);
  const [filteredDeviceList, setFilteredDeviceList] = useState([]);
  const [filteredRouteList, setFilteredRouteList] = useState([]);

  const handleCompanyChange = (companyId) => {
    try {
      if (!companyId) {
        setFilteredVehicleList([]);
        setFilteredDeviceList([]);
        setFilteredRouteList([]);
        return;
      }

      const filteredVehicles = vehicleList.filter(
        (v) => v.FAgentGUID === companyId,
      );

      const filteredDevices = deviceList.filter(
        (d) => d.FAgentGUID === companyId,
      );
      const filteredRoutes = routeList.filter(
        (r) => r.FAgentGUID === companyId,
      );

      setFilteredVehicleList(filteredVehicles);
      setFilteredDeviceList(filteredDevices);
      setFilteredRouteList(filteredRoutes);
    } catch (error) {
      console.error("[handleCompanyChange] error:", error);
    }
  };
  useEffect(() => {
    handleCompanyChange(
      userInfo?.MCID === 59 ? formData?.company : userInfo?.ECTSCompId || "",
    );
  }, [formData.company, vehicleList, deviceList, routeList]);

  const handleSubmitForm = async (values) => {
    setNewLoading(true);
    try {
const vehId =
        vehicleOptions.find((v) => v.label === formData.vehicle)?.value || "";
      const vehRegNo = formData.vehicle || "";

      const deviceName =
        deviceOptions.find((d) => d.value === formData.device)?.label || "";

      const routeName =
        routeOptions.find((r) => r.value === formData.route)?.label || "";

      const consignorName =
        companyOptions.find((c) => c.value === formData.company)?.label || "";

      const payload = {
        VehId: vehId,
        VehRegNo: vehRegNo,
        TripType: formData?.triptype,
        FCompGUID:
          userInfo?.MCID === 59
            ? formData?.company
            : userInfo?.ECTSCompId || "",
        FinishType: formData?.finishtype,
        ShipmentTypeId: formData?.shipmenttype,
        MCID: userInfo?.MCID,
        CRBY: userInfo?.UID,
        FreeDays: formData?.freedays
          ? dayjs(formData.freedays).format("YYYY-MM-DD")
          : null,
        DriverName: formData.driver,
        DriverPhone: formData.phone,
        temporaryContainerConsignmentList: [
          {
            CONSIGNID: -1,
            DeviceName: deviceName,
            DeviceID: formData?.device,
            RouteName: routeName,
            ContainerNo: formData?.container,
            CustId: formData?.consignor,
            ConsignorID:
              userInfo?.MCID === 59
                ? formData?.company
                : userInfo?.ECTSCompId || "",
            ConsignorName:
              userInfo?.MCID === 59 ? consignorName : userInfo?.COMPNAME || "",
            TransporterId: formData?.transporter,
            ConsigneeID: formData?.consignee,
            DispatchTypeID: formData?.dispatchtype,
            DispatchTypeName:
              DispatchType.find((item) => item.value === formData?.dispatchtype)
                ?.name || "",
            Priority: formData?.priority || 1,
            PickUpDateTime: formData?.pickup,
            DropOffDateTime: formData?.dropoff,
            RouteID: formData?.route,
            FWayBillGUID: "",
            FCompGUID:
              userInfo?.MCID === 59
                ? formData?.company
                : userInfo?.ECTSCompId || "",
            FWayBill: formData?.delivery,
            TripType: formData?.triptype,
            ShipmentTypeId: formData?.shipmenttype,
            MCID: userInfo?.MCID,
            CRBY: userInfo?.UID,
          },
        ],
      };
      const { ResponseCode, data } = await CALL_API(
        "POST",
        "container/bulkPost",
        payload,
      );

      if (ResponseCode !== 200) {
        setNewLoading(false);
        message.error(data);
        return;
      }
      message.success("Trip created successfully!");
      fetchTrips();
      setNewLoading(false);
      setDrawyeropen(false);
    } catch (error) {
      console.error("Submit Error:", error);
      message.error("Failed to submit data. Please try again.");
    }
  };

  const handleOpen = () => {
    setDrawyeropen(true);
  };
  const handleClose = () => {
    setDrawyeropen(false);
    setIsEdit(false);
    setFormData({
      company: userInfo?.MCID === 59 ? "" : userInfo?.COMPNAME || "",
      consignor: "",
      transporter: "",
      priority: "",
      dispatchtype: "",
      shipmenttype: "",
      pickup: "",
      dropoff: "",
      vehicle: "",
      triptype: "",
      finishtype: "",
      consignee: "",
      device: "",
      container: "",
      delivery: "",
      route: "",
      freedays: "",
      driver: "",
      phone: "",
    });
    form.resetFields();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
    if (field === "company") {
      setFormData((prevData) => ({
        ...prevData,
        company: value,
      }));
      handleCompanyChange(value);
    }
  };

  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );
      const data = await response.json();
      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };

  const exportTrips = async () => {
    try {
      setCSVLoader(true);
      // Format dates
      const fromDateFormatted = filterValues?.fromdate
        ? dayjs(filterValues.fromdate).format("YYYY-MM-DD")
        : "";
      const toDateFormatted = filterValues?.todate
        ? dayjs(filterValues.todate).format("YYYY-MM-DD")
        : "";
      // Fetch trips
      const { data } = await CALL_API(
        "GET",
        `container/pagination?page=${currentPage}&limit=${pageSize}&ContainerNo=${
          filterValues?.container
        }&Consignee=${filterValues?.consignee || ""}&TripStatus=${
          filterValues?.status
        }&FromDate=${fromDateFormatted}&ToDate=${toDateFormatted}&Transporter=${
          filterValues?.transporter || ""
        }&Consignor=${filterValues?.consignor || ""}&ShipmentTypeId=${
          filterValues?.shipment
        }`,
      );
      let trips = data?.data || [];
      // 1. Enrich with monitor data + location (ASYNC MAP)
      trips = await Promise.all(
        trips.map(async (trip) => {
          const monitor = tripMonitorData.find(
            (item) => item.FAssetID === trip.DeviceName,
          );
          const vehicleReg = Array.isArray(trip.VEHREGNO)
            ? trip.VEHREGNO[0]
            : trip.VEHREGNO;

          const vehicleData = vehicleList.find(
            (v) => v.FVehicleName === vehicleReg,
          );

          let locationName = "";
          if (monitor?.FLatitude && monitor?.FLongitude) {
            locationName = await fetchLocation(
              monitor.FLatitude,
              monitor.FLongitude,
            );
          }
          return {
            ...trip,
            Battery: monitor?.FBattery || "0",
            LastStatus: monitor?.FLockStatus ?? null,
            Location: locationName,
            Speed: monitor?.FSpeed || 0,
            FDriverName: vehicleData?.FDriverName || "-",
            FDriverPhoneNumber: vehicleData?.FDriverPhoneNumber || "-",
          };
        }),
      );
      // 2. Fetch mileage for each trip (PARALLEL CALLS)
      const mileageResponses = await Promise.all(
        trips.map((trip) =>
          CALL_API(
            "GET",
            `container/getTransportationReport?aTripId=${trip.TRIPID}`,
          ),
        ),
      );
      trips = trips.map((trip, index) => ({
        ...trip,
        TransportationMileage:
          mileageResponses[index]?.data?.[0]?.TransportationMileage || "0",
      }));
      // 3. Prepare final data for CSV
      const finalData = trips.map((item) => ({
        "Trip Started": item.CRON ? dayjs(item.CRON).format("YYYY/MM/DD") : "-",
        Company: userInfo?.COMPNAME || "-",
        Consignor: item.Consignor || "-",
        Consignee: item.ConsigneeName || "-",
        Transporter: item.Transporter || "-",
        "Container No": Array.isArray(item.ContainerNo)
          ? item.ContainerNo[0] || "-"
          : item.ContainerNo || "-",
        "Free Days": item.DaysLeft !== null ? item.DaysLeft : "-",
        "Vehicle Reg": Array.isArray(item.VEHREGNO)
          ? item.VEHREGNO[0] || "-"
          : item.VEHREGNO || "-",
        "Driver Name": item.DriverName || "-",
        "Driver No": item.DriverPhone || "-",
        "Last Location": item.Location || "-",
        "Last Event": item.LastEvent || "-",
        "Trip Status": item.TripStatus || "-",
        "Lock Status":
          item.LastStatus === 0
            ? "Locked"
            : item.LastStatus === 1
              ? "Unlocked"
              : "-",
        "Movement Status": item.Speed === 0 ? "Not Moving" : "Moving",
        "Trip End Date": item.TripEndDate
          ? dayjs(item.TripEndDate).format("YYYY/MM/DD")
          : "-",
      }));
      setCSVList(finalData);
      // Trigger download AFTER setting data
      setTimeout(() => {
        if (csvLinkEl.current) {
          csvLinkEl.current.link.click();
        }
      }, 100);
    } catch (error) {
      console.error("CSV export error -->", error);
      message.error(
        "Failed to prepare CSV. " + (error?.response?.data?.message || ""),
      );
    } finally {
      setCSVLoader(false);
    }
  };

  const CSVs = () => {
    setLoading(true);
    exportTrips(); // No need to click manually here anymore
    setLoading(false);
  };
  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= 320 && window.innerWidth <= 480,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= 320 && window.innerWidth <= 480);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const columns1 = [
    ...(isMobile
      ? [
          {
            title: "Container No",
            dataIndex: "ContainerNo",
            key: "ContainerNo",
            fixed: "left",
            width: 150,
            render: (text) => {
              if (Array.isArray(text)) {
                return text[0] || "-";
              }
              // return text || "-";
            },
          },
        ]
      : []),
    {
      title: "Date",
      dataIndex: "CRON",
      key: "CRON",
      width: "20%",
      render: (text) =>
        text ? dayjs.utc(text).tz("Africa/Nairobi").format("DD/MM/YYYY") : "-",
    },
    {
      title: (
        <div>
          <span>Consign</span>
          <br />
          <span>Code</span>
        </div>
      ),
      dataIndex: "CODE",
      key: "CODE",
      width: "20%",
    },
    ...(isMobile
      ? []
      : [
          {
            title: "Container No",
            dataIndex: "ContainerNo",
            key: "ContainerNo",
            width: "20%",
            render: (text) => {
              if (Array.isArray(text)) {
                return text[0] || "-";
              }
              // return text || "-";
            },
          },
        ]),
    {
      title: "Free Days",
      dataIndex: "DaysLeft",
      key: "DaysLeft",
      width: "20%",
      render: (e, record) => {
        let displayColor;
        if (record?.DaysLeft === null || record?.DaysLeft === undefined) {
          displayColor = <p className="">{record?.DaysLeft}</p>;
        } else if (record?.DaysLeft >= 3) {
          displayColor = (
            <p className="container_Green">
              {record?.DaysLeft}
              <span>Days</span>
            </p>
          );
        } else if (record?.DaysLeft >= 2 && record?.DaysLeft < 3) {
          displayColor = (
            <p className="container_Orange">
              {record?.DaysLeft}
              <span>Days</span>
            </p>
          );
        } else if (record?.DaysLeft < 2 && record?.DaysLeft >= 0) {
          displayColor = (
            <p className="container_Red">
              {record?.DaysLeft}
              <span>Day</span>
            </p>
          );
        } else if (record?.DaysLeft < 0) {
          displayColor = (
            <p className="container_Red">
              {record?.DaysLeft}
              <span>Days</span>
            </p>
          );
        }
        return (
          <>
            <div>{displayColor}</div>
          </>
        );
      },
    },
    {
      title: "Transporter",
      dataIndex: "Transporter",
      key: "Transporter",
      width: "20%",
      render: (text) => text || "-",
    },
    {
      title: "Vehicle No",
      dataIndex: "VEHREGNO",
      key: "VEHREGNO",
      width: "20%",
      render: (text) => {
        if (Array.isArray(text)) {
          return text[0] || "-";
        }
        // return text || "-";
      },
    },
    {
      title: "Device ID",
      dataIndex: "DeviceName",
      key: "DeviceName",
      width: "20%",
      render: (text) => text || "-",
    },
    {
      title: "Last Event",
      dataIndex: "LastEvent",
      key: "LastEvent",
      width: "20%",
      render: (text, record) => {
        if (record?.TripStatus === "Completed") {
          return "Finished";
        }
        return text || "-";
      },
    },
    {
      title: "Consignee",
      dataIndex: "ConsigneeName",
      key: "ConsigneeName",
      width: "20%",
      render: (text) => text || "-",
    },
    {
      title: "Status",
      dataIndex: "LastStatus",
      key: "LastStatus",
      width: "20%",
      render: (lastStatus, record) => {
        let icon = null;
        if (lastStatus === 0) {
          icon = <Lock style={{ width: "22px", height: "22px" }} />;
        } else if (lastStatus === 1) {
          icon = <UnLock style={{ width: "22px", height: "22px" }} />;
        }
        return (
          <Customstyle>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span>
                {record?.TripStatus === "Completed" ? (
                  <p className="container_green">{record?.TripStatus}</p>
                ) : (
                  <p className="container_red">{record?.TripStatus}</p>
                )}
              </span>
              {icon}
            </div>
          </Customstyle>
        );
      },
    },
    {
      title: (
        <div>
          <span>Battery</span>
          <br />
          <span>Kms</span>
        </div>
      ),
      dataIndex: "FBattery",
      key: "FBattery",
      width: "20%",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Battery style={{ width: "16px", height: "16px" }} />
            <span
              style={{ fontWeight: 500, fontSize: "14px", color: "#5F6D8C" }}
            >
              {record?.Battery || "N/A"} %
            </span>
          </div>
          <i style={{ fontWeight: 500, fontSize: "14px", color: "#5F6D8C" }}>
            {record?.TransportationMileage || "N/A"} Kms
          </i>
        </div>
      ),
    },
    // {
    //   title: "Files",
    //   dataIndex: "files",
    //   key: "files",
    //   width: "20%",
    //   render: (text) => (
    //     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
    //       <File style={{ width: "24px", height: "24px" }} />
    //     </div>
    //   ),
    // },
    {
      title: "Track",
      dataIndex: "track",
      key: "track",
      width: "20%",
      render: (_, record) => (
        <Track
          style={{ cursor: "pointer" }}
          onClick={(event) => {
            event.stopPropagation();
            window.open(
              `/tripTrack/${record.TRIPID}?vehId=${record.VEHID}&shipmentTypeId=${record?.ShipmentTypeId}&MCID=${userInfo?.MCID}&UID=${userInfo?.UID}`,
            );
          }}
        />
      ),
    },
  ].filter(Boolean);

  const companyOptions = companyList?.map((item) => ({
    value: item.FAgentGUID,
    label: item.FName,
  }));
  const vehicleOptions = filteredVehicleList?.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
  }));
  const routeOptions = filteredRouteList?.map((item) => ({
    value: item.FRouteGUID,
    label: item.FRouteName,
  }));
  const deviceOptions = filteredDeviceList?.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));
  const vehicleFilterOptions = vehicleList?.map((item) => ({
    value: item.FGUID,
    label: item.FVehicleName,
  }));
  const deviceFilterOptions = deviceList?.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCustomFields();
  }, [reftab]);

  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];

  const customfielvalues = Array.isArray(customFields)
    ? customFields.map((item, index) => {
        const isdropdown = item?.FIELDTYPE === 1;
        const DATASOURCE =
          isdropdown && item?.DATASOURCE
            ? item?.DATASOURCE?.split(",").map((item, index) => {
                return { label: item.trim(), value: item.trim() };
              })
            : [];
        return {
          id: 18 + index,
          label: item.FIELDNAME.replace(/_/g, " ").replace(/\b\w/g, (l) =>
            l.toUpperCase(),
          ),
          type: isdropdown ? "selectwithvalue" : "text" || "checkbox",
          name: item.FIELDNAME,
          options: DATASOURCE,
          maxLength: item.MAXLEN || 50,
          validationRules: item.REQUIRED
            ? [{ required: true, message: `${item.FIELDNAME} is required` }]
            : [],
        };
      })
    : [];

  const AddEditForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              id: 0,
              label: (
                <b
                  className={isMobile ? "assignment-title-mobile" : ""}
                  style={{
                    color: "black",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  Trip Configuration
                </b>
              ),
              type: "phone",
            },
            ...(!isMobile ? [{}, {}, {}] : []),
          ],
          [
            {
              id: 1,
              label: "Company",
              type: "selectwithvalue",
              name: "company",
              disabled: userInfo?.MCID !== 59,
              options: companyOptions,
              maxLength: 50,
              style: { width: "259px", height: "36px", gap: "10px" },
              validationRules: [
                { required: true, message: "Company is required" },
              ],
            },
            {
              id: 2,
              label: "Consignor",
              type: "selectwithvalue",
              name: "consignor",
              placeholder: "Enter First Name",
              options: consignerList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
              maxLength: 50,
              validationRules: [
                { required: true, message: "Consignor is required" },
              ],
            },
            {
              id: 3,
              label: "Consignee",
              type: "selectwithvalue",
              name: "consignee",
              options: consigneeList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
              validationRules: [
                { required: true, message: "Consignee is required" },
              ],
            },
            {
              id: 4,
              label: "Transporter",
              type: "selectwithvalue",
              name: "transporter",
              placeholder: "Enter Last Name",
              maxLength: 50,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.ID,
              })),
              style: { width: "259px", height: "36px", gap: "10px" },
              validationRules: [
                { required: true, message: "Transporter is required" },
              ],
            },
          ],
          [
            {
              id: 5,
              label: "Dispatch Type",
              type: "selectwithvalue",
              name: "dispatchtype",
              options: DispatchType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Dispatch Type is required" },
              ],
            },
            {
              id: 6,
              label: "Shipment Type",
              type: "selectwithvalue",
              name: "shipmenttype",
              options: ShipmentType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              placeholder: "Enter Phone Number",
              style: { width: "259px", height: "36px", gap: "10px" },
              validationRules: [
                { required: true, message: "Shipment Type is required" },
              ],
            },
            {
              id: 10,
              label: "Trip Type",
              type: "selectwithvalue",
              name: "triptype",
              options: TripTypeEnum?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Trip Type is required" },
              ],
            },
            {
              id: 11,
              label: "Finish Type",
              type: "selectwithvalue",
              name: "finishtype",
              options: FinishType?.map((item) => ({
                label: item.name,
                value: item.value,
              })),
              validationRules: [
                { required: true, message: "Finish Type is required" },
              ],
            },
          ],
          [
            {
              id: 7,
              label: "Pickup Date Time",
              type: "date",
              name: "pickup",
              showtime: true,
              format: "YYYY-MM-DD HH:mm:ss",
              validationRules: [
                { required: true, message: "Pickup Date Time is required" },
              ],
            },
            {
              id: 8,
              label: "Dropoff Date Time",
              type: "date",
              name: "dropoff",
              showtime: true,
              format: "YYYY-MM-DD HH:mm:ss",
              validationRules: [
                { required: true, message: "Dropoff Date Time is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const pickup = getFieldValue("pickup");
                    if (!value || !pickup) return Promise.resolve();

                    if (dayjs(value).isAfter(dayjs(pickup))) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Drop-off Date & Time must be later than Pick-up Date & Time.",
                      ),
                    );
                  },
                }),
              ],
            },
            {
              id: 17,
              label: "Free Days",
              type: "date",
              name: "freedays",
              showtime: false,
              placeholder: "Select Date",
              format: "YYYY-MM-DD",
              validationRules: [
                { required: false, message: "Free Days is required" },
              ],
            },
            {
              id: 16,
              label: "Route",
              type: "selectwithvalue",
              name: "route",
              options: routeOptions,
              validationRules: [
                { required: true, message: "Route is required" },
              ],
            },
          ],
          [
            {
              id: 0,
              label: (
                <b
                  className={isMobile ? "assignment-title-mobile" : ""}
                  style={{
                    color: "black",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  Vehicle & Container Assignment
                </b>
              ),
              type: "phone",
            },
            ...(!isMobile ? [{}, {}, {}] : []),
          ],
          [
            {
              id: 9,
              label: "Vehicle",
              type: "textorselect",
              name: "vehicle",
              Placeholder: "Select or enter a vehicle",
              options: vehicleOptions,
              validationRules: [
                { required: true, message: "Vehicle is required" },
              ],
            },
            {
              id: 13,
              label: "Device",
              type: "selectwithvalue",
              name: "device",
              options: deviceOptions,
              validationRules: [
                { required: true, message: "Device is required" },
              ],
            },
            {
              id: 9,
              label: "Driver Name",
              type: "text",
              name: "driver",
              options: vehicleOptions,
              validationRules: [
                { required: true, message: "Driver Name is required" },
              ],
            },
            {
              id: 9,
              label: "Phone",
              type: "text",
              name: "phone",
              validationRules: [
                { required: true, message: "Phone is required" },
              ],
            },
          ],
          [
            {
              id: 14,
              label: "Container Number",
              type: "text",
              name: "container",
              validationRules: [
                { required: true, message: "Container No. is required" },
              ],
            },
            {
              id: 15,
              label: "Delivery Note Number",
              type: "text",
              name: "delivery",
              validationRules: [
                { required: true, message: "Deliver No. is required" },
              ],
            },
            //   // {
            //   //   id: 4,
            //   //   label: "Priority",
            //   //   type: "selectwithvalue",
            //   //   name: "priority",
            //   //   options: priorityType?.map((item) => ({
            //   //     label: item.name,
            //   //     value: item.value,
            //   //   })),
            //   //   maxLength: 50,
            //   //   style: { width: "259px", height: "36px", gap: "10px" },
            //   //   validationRules: [
            //   //     { required: true, message: "Priority is required" },
            //   //   ],
            //   // },
            {},
            {},
          ],
        ],
      },
    ],
  };
  const customFieldsWithColSpan = customfielvalues.map((field) => ({
    ...field,
    colSpan: 6,
  }));

  const groupedCustomFields = [];
  for (let i = 0; i < customFieldsWithColSpan.length; i += 4) {
    groupedCustomFields.push(customFieldsWithColSpan.slice(i, i + 4));
  }
  // Step 3: Merge with AddEditForm
  const combinedForm = {
    ...AddEditForm,
    pages: AddEditForm.pages.map((page) => ({
      ...page,
      fields: [...page.fields, ...groupedCustomFields],
    })),
  };
const isDataReady = typeof loading !== "undefined" ? !loading : Boolean(total || completedCount || inProgressCount || assignedCount);

  return (
    <Customstyle>
      <Card style={{ background: "white" }}>
        {window.innerWidth >= 320 && window.innerWidth <= 426 ? (
          <>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ flexWrap: "wrap", gap: "8px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexWrap: "wrap",
                }}
              >
                <div className="total">{total} Trips</div>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    background: !isDataReady
                      ? "#E7E8E9"
                      : completedCount === 0
                        ? "#E7E8E9"
                        : "#33C24A2B",
                    borderRadius: "20px",
                    padding: "3px 10px",
                    fontSize: "12px",
                    color: !isDataReady
                      ? "#595959"
                      : completedCount === 0
                        ? "#595959"
                        : "#1a6b28",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background: !isDataReady
                        ? "#A8A8A8"
                        : completedCount === 0
                          ? "#595959"
                          : "#2C963D",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  {isDataReady ? `${completedCount} Completed` : "0 Completed"}
                </span>

                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    background: !isDataReady
                      ? "#E7E8E9"
                      : inProgressCount === 0
                        ? "#E7E8E9"
                        : "#BF901826",
                    borderRadius: "20px",
                    padding: "3px 10px",
                    fontSize: "12px",
                    color: !isDataReady
                      ? "#595959"
                      : inProgressCount === 0
                        ? "#595959"
                        : "#9a6800",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background: !isDataReady
                        ? "#A8A8A8"
                        : inProgressCount === 0
                          ? "#595959"
                          : "#E4A400",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  {isDataReady
                    ? `${inProgressCount} In Progress`
                    : "0 In Progress"}
                </span>

                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    background: !isDataReady
                      ? "#E7E8E9"
                      : assignedCount === 0
                        ? "#E7E8E9"
                        : "transparent",
                    borderRadius: "20px",
                    padding: "3px 10px",
                    fontSize: "12px",
                    color: !isDataReady
                      ? "#595959"
                      : assignedCount === 0
                        ? "#595959"
                        : "#E4A400",
                    border: !isDataReady
                      ? "none"
                      : assignedCount === 0
                        ? "none"
                        : "1px solid #E4A400",
                  }}
                >
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background: !isDataReady
                        ? "#A8A8A8"
                        : assignedCount === 0
                          ? "#595959"
                          : "#E4A400",
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  {isDataReady ? `${assignedCount} Loaded` : "0 Loaded"}
                </span>
              </div>
              <div className="container_for_header_subtwo">
                <div>
                  {/* <Spin spinning={CSVLoader}>
              <img
                src={ExportIcon}
                style={{
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={CSVs}
              />
            </Spin> */}

                  {/* <CSVLink
              data={CSVList}
              ref={csvLinkEl}
              filename="TripsMonitoring.csv"
              style={{ display: "none" }}
            /> */}

                  <Button
                    className="Iconbg"
                    onClick={() => setFilterModalOpen(true)}
                  >
                    <Space size="middle">
                      <Badge size="small" count={filterCount}>
                        <Filter />{" "}
                      </Badge>
                    </Space>
                  </Button>
                  {/* <ButtonOutlined
              onClick={() => setIsconfigModalVisible(true)}
              className="Create_btn"
            >
              Configure
            </ButtonOutlined> */}
                  <Tooltip title={!createAllowed ? "No permission" : ""}>
                    <ButtonFilled
                      style={{
                        cursor: createAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!createAllowed) return;
                        handleOpen();
                      }}
                    >
                      + Create
                    </ButtonFilled>
                  </Tooltip>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ flexWrap: "wrap", gap: "8px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              <div className="total">{total} Trips</div>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  background: !isDataReady
                    ? "#E7E8E9"
                    : completedCount === 0
                      ? "#E7E8E9"
                      : "#33C24A2B",
                  borderRadius: "20px",
                  padding: "3px 10px",
                  fontSize: "12px",
                  color: !isDataReady
                    ? "#595959"
                    : completedCount === 0
                      ? "#595959"
                      : "#1a6b28",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: !isDataReady
                      ? "#A8A8A8"
                      : completedCount === 0
                        ? "#595959"
                        : "#2C963D",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                {isDataReady ? `${completedCount} Completed` : "0 Completed"}
              </span>

              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  background: !isDataReady
                    ? "#E7E8E9"
                    : inProgressCount === 0
                      ? "#E7E8E9"
                      : "#BF901826",
                  borderRadius: "20px",
                  padding: "3px 10px",
                  fontSize: "12px",
                  color: !isDataReady
                    ? "#595959"
                    : inProgressCount === 0
                      ? "#595959"
                      : "#9a6800",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: !isDataReady
                      ? "#A8A8A8"
                      : inProgressCount === 0
                        ? "#595959"
                        : "#E4A400",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                {isDataReady
                  ? `${inProgressCount} In Progress`
                  : "0 In Progress"}
              </span>

              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  background: !isDataReady
                    ? "#E7E8E9"
                    : assignedCount === 0
                      ? "#E7E8E9"
                      : "transparent",
                  borderRadius: "20px",
                  padding: "3px 10px",
                  fontSize: "12px",
                  color: !isDataReady
                    ? "#595959"
                    : assignedCount === 0
                      ? "#595959"
                      : "#E4A400",
                  border: !isDataReady
                    ? "none"
                    : assignedCount === 0
                      ? "none"
                      : "1px solid #E4A400",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: !isDataReady
                      ? "#A8A8A8"
                      : assignedCount === 0
                        ? "#595959"
                        : "#E4A400",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                {isDataReady ? `${assignedCount} Loaded` : "0 Loaded"}
              </span>
            </div>
            <div className="container_for_header_subtwo">
              <div>
                <Spin spinning={CSVLoader}>
                  <Tooltip title={!exportAllowed ? "No permission" : ""}>
                    <img
                      src={ExportIcon}
                      style={{
                        marginRight: "10px",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        CSVs();
                      }}
                    />
                  </Tooltip>
                </Spin>

                <CSVLink
                  data={CSVList}
                  ref={csvLinkEl}
                  filename="TripsMonitoring.csv"
                  style={{ display: "none" }}
                />

                <Button
                  className="Iconbg"
                  onClick={() => setFilterModalOpen(true)}
                >
                  <Space size="middle">
                    <Badge size="small" count={filterCount}>
                      <Filter />{" "}
                    </Badge>
                  </Space>
                </Button>
                <ButtonOutlined
                  onClick={() => setIsconfigModalVisible(true)}
                  className="Create_btn"
                >
                  Configure
                </ButtonOutlined>
                <Tooltip title={!createAllowed ? "No permission" : ""}>
                  <ButtonFilled
                    style={{
                      cursor: createAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!createAllowed) return;
                      handleOpen();
                    }}
                  >
                    + Create
                  </ButtonFilled>
                </Tooltip>
              </div>
            </div>
          </div>
        )}
        <UIModal
          width={600}
          height={600}
          open={isconfigModalVisible}
          onClose={() => {
            setIsconfigModalVisible(false);
          }}
          closeButton={false}
          size="md"
          header={
            <div className="text-start">
              <h2>Customized Column</h2>
              <label
                style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
              >
                Columns
              </label>
            </div>
          }
          footer={
            <div className="mt-2 w-100 d-flex justify-content-end">
              <ButtonFilled
                onClick={() => {
                  setIsconfigModalVisible(false); // Close the modal
                }}
              >
                Save
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsconfigModalVisible(false); // Just close the modal
                }}
              >
                Cancel
              </Buttontransparent>
            </div>
          }
        >
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select custom columns"
            value={selectedCustomColumns}
            onChange={setSelectedCustomColumns}
            dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
            dropdownRender={(menu) => (
              <div>
                <Checkbox.Group
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "8px 12px",
                  }}
                  value={selectedCustomColumns}
                  onChange={setSelectedCustomColumns}
                >
                  {customFieldOptions.map((option) => (
                    <Checkbox
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                    >
                      {option.label}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            )}
          >
            {customFieldOptions.map((option) => (
              <Select.Option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </UIModal>
        {loading && !initialized ? (
          <Spin spinning />
        ) : tripData.length > 0 ? (
          <>
            <StyledTable
              className="mt-4"
              dataSource={tripData}
              columns={columns1}
              pagination={false}
              style={{ cursor: "pointer" }}
              onRow={(record) => ({
                onClick: () => {
                  navigate(`/TripDetails/${record.TRIPID}`, {
                    state: { ...record },
                  });
                },
              })}
              rowKey="TRIPID"
            />
            <ReusablePagination
              pageSize={pageSize}
              handlePageSizeChange={handlePageSizeChange}
              currentPage={currentPage}
              total={total}
              handlePageChange={handlePageChange}
            />
          </>
        ) : (
          <Spin></Spin> // Avoids the spinner getting stopped and then fetching the datas all of a sudden.
        )}

        <ReusableDrawer
          title={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              {isEdit ? "Modifying Consignment" : "Creating New Consignment"}
            </div>
          }
          open={drawyeropen}
          setOpen={setDrawyeropen}
          onOk={handleSubmitForm}
          onClose={handleClose}
          closable={false}
          footer={[
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Buttontransparent
                key="cancel"
                className="cancel-btn"
                onClick={handleClose}
              >
                Cancel
              </Buttontransparent>
              <ButtonFilled onClick={() => form.submit()} loading={newLoading}>
                {isEdit ? "Update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
          children={
            <GridBuilder
              grid={formData}
              // formStructureJson={AddEditForm}
              formStructureJson={combinedForm}
              handleChange={handleChange}
              formSubmit={handleSubmitForm}
              initialValues={formData}
              form={form}
              handleSelectChange={handleSelectChange}
            />
          }
        />
        <Modal
          open={filterModalOpen}
          onCancel={() => setFilterModalOpen(false)}
          width={900}
          footer={
            <ButtonFilled
              onClick={() => {
                setFilterValues({
                  container: "",
                  consignee: "",
                  lockstatus: "",
                  status: "",
                  fromdate: "",
                  todate: "",
                  transporter: "",
                  consignor: "",
                  shipment: "",
                }); // Reset the state
                filterform?.setFieldsValue({
                  container: "",
                  consignee: "",
                  lockstatus: "",
                  status: "",
                  fromdate: "",
                  todate: "",
                  transporter: "",
                  consignor: "",
                  shipment: "",
                }); // Reset the form fields
                setFilterCount(0);
                setFilterModalOpen(false);
              }}
            >
              {" "}
              Clear All{" "}
            </ButtonFilled>
          }
        >
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <h6 className="Filter_for_clickablerow">
                  Filter ({filterCount})
                </h6>
                {/* <p className="Filter_for_Result">4 Result Found </p> */}
              </div>
            </Col>
          </Row>
          <Form
            form={filterform}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              const count = Object.values(allvalues).filter(
                (val) =>
                  val !== undefined &&
                  val !== null &&
                  String(val).trim() !== "",
              ).length;

              setFilterCount(count);
              setFilterValues(allvalues);
            }}
            initialValues={filterValues}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Container Number" name="container">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignee" name="consignee">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consigneeList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Lock Status" name="lockstatus">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={LockStatus?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip Status" name="status">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={TripStatus?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Date From" name="fromdate">
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Date To" name="todate">
                  <DatePicker className="w-100" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.Name,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Shipment Type" name="shipment">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={ShipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Vehicle" name="vehicle">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={vehicleFilterOptions?.map((item) => ({
                      label: item.label,
                      value: item.label,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Device" name="device">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={deviceFilterOptions?.map((item) => ({
                      label: item.label,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Card>
    </Customstyle>
  );
}

export default TripMonitoring;
